module.exports = __webpack_public_path__ + "img/HQ-ENC-H-V1.2b918669.jpg";